const PlayCircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M35 20C35 28.2843 28.2843 35 20 35C11.7157 35 5 28.2843 5 20C5 11.7157 11.7157 5 20 5C28.2843 5 35 11.7157 35 20Z"
        stroke="#149DFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5166 19.4536C26.9452 19.6918 26.9452 20.3082 26.5166 20.5463L17.1785 25.7342C16.7619 25.9656 16.25 25.6644 16.25 25.1878V14.8122C16.25 14.3356 16.7619 14.0344 17.1785 14.2658L26.5166 19.4536Z"
        stroke="#149DFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlayCircleIcon;
